<template>
  <div>
    <v-text-field
      outlined
      v-model="v"
      :label="model.title"
      :error-messages="error"
      :disabled="model.disabled || config.disabled || false"
      :hide-details="config.hideDetails || false"
      :dense="config.dense || false"
      :readonly="readonly"
      @input_="$emit('input', $event)"
      @keypress="filter($event)"
      append-outer-icon="mdi-text-box-search-outline"
      @click:append-outer="getInfo()"
    />
    <v-dialog v-model="dialog" max-width="800">
      <v-card>
        <v-card-title class="text-h5"> Результат поиска по ИНН</v-card-title>

        <v-tabs v-model="tab" background-color="primary" dark>
          <v-tab v-for="(item, key) in info" :key="key">
            {{ key + 1 }}
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item v-for="(item, key) in info" :key="key">
            <a-form-view :model="info_model" :value="item" @actionClick="onClickAction($event)"></a-form-view>
          </v-tab-item>
        </v-tabs-items>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" text @click="dialog = false"> Закрыть </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
const _ = require("lodash");
export default {
  props: {
    value: [String, Number],
    model: Object,
    config: { type: Object, default: {} },
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: "",
    },
    values: Object,
  },
  data() {
    return {
      dialog: false,
      tab: null,
      _info_model: [
        { name: "name", title: "Наименование", type: "string", path: "value", iconAction: "fas fa-pen-nib" },
        { name: "type", title: "Тип", type: "string", path: "data.opf.full" },
        { name: "inn", title: "ИНН", type: "string", path: "data.inn", hidden: !true },
        { name: "kpp", title: "КПП", type: "string", path: "data.kpp", iconAction: "fas fa-pen-nib" },
        { name: "ogrn", title: "ОГРН", type: "string", path: "data.ogrn", iconAction: "fas fa-pen-nib" },
        { name: "address", title: "Адрес", type: "string", path: "data.address.value", iconAction: "fas fa-pen-nib" },
        { name: "city", title: "Город", type: "string", path: "data.address.data.city", iconAction: "fas fa-pen-nib" },
      ],
      info: [],
    };
  },

  computed: {
    info_model() {
      return this.model?.info_model || this._info_model;
    },
    v: {
      get() {
        // Если первые три символа "996", убираем их
        if (this.model.prepend)
          if ((this.value || "").startsWith(this.model.prepend)) {
            return this.value.slice(this.model.prepend.length);
          }
        if (this.model.format) {
          let format = [/(\d{1})(\d{3})(\d{3})(\d{2})(\d{2})(\d{2})/, "+$1 ($2) $3-$4-$5-$6"];
          return this.value.replace(format[0], format[1]);
        }
        return this.value;
      },
      set(v) {
        let result = (this.model.prepend || "") + `${v}`;
        //  if (typeof result === "string" && result) result = parseInt(result);

        this.$emit("input", result);
      },
    },
    readonly() {
      if (this.config?.readonly || this.model?.readonly) return true;
      return false;
    },
    isDisable() {
      return this.model?.disabled || this.disabled;
    },
  },
  methods: {
    filter: function (evt) {
      evt = evt ? evt : window.event;
      let expect = evt.target.value.toString() + evt.key.toString();

      if (!/^[0-9]*\.?\,?[0-9]*$/.test(expect)) {
        evt.preventDefault();
        //evt = "";
        //return true;
      } else {
        return true;
      }
    },
    async getInfo() {
      let api = "/accounting/dir/vendor/get_vendor_info/";
      if (!api) return;
      let type = "get";

      if (!api) return;

      let resp = await this.$axios.get(api + this.v);
      const data = resp.data.data || [];
      let info = [];
      console.log(data);
      data.forEach(d => {
        let i = {};
        this.info_model.forEach(inf => {
          i[inf.name] = _.get(d, inf.path);
        });
        info.push(i);
      });
      this.info = [...info];
      this.loading = false;
      this.dialog = true;
    },
    onClickAction(e) {
      this.$emit("cascade", { field: e.name, value: e.value });
    },
  },
};
</script>
